import { render, staticRenderFns } from "./AbsaPayLogo.vue?vue&type=template&id=0cb89dd4&scoped=true"
import script from "./AbsaPayLogo.vue?vue&type=script&lang=js"
export * from "./AbsaPayLogo.vue?vue&type=script&lang=js"
import style0 from "./AbsaPayLogo.vue?vue&type=style&index=0&id=0cb89dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb89dd4",
  null
  
)

export default component.exports